import Project from './Project.vue';

export default Project;
